export const getCleanShopifyId = (id?: string | null): string => {
  if (!id) {
    return '';
  }

  const stringId = id.toString();

  if (stringId.startsWith('gid://shopify')) {
    const gidSplit = stringId.split('/');
    const shopifyId = gidSplit[gidSplit.length - 1];

    return shopifyId?.split('?')[0] ?? '';
  }

  return stringId;
};
